export class InputString {
    public value: string = "";
    public error: string = "";
    public disabled ?: boolean = false;
}